// Client-side Sentry/GlitchTip configuration for Next.js.
// Next.js loads this file in the browser before hydration.
;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/domains/:id\",\"regex\":\"^/domains/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/qr-codes/:id/edit\",\"regex\":\"^/qr-codes/([^/]+)/edit$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/tickets/:id\",\"regex\":\"^/tickets/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/analytics\"},{\"path\":\"/analytics/logs\"},{\"path\":\"/connect\"},{\"path\":\"/domains\"},{\"path\":\"/email\"},{\"path\":\"/email/workflow\"},{\"path\":\"/gallery\"},{\"path\":\"/health/sentry\"},{\"path\":\"/links\"},{\"path\":\"/mappings\"},{\"path\":\"/mappings/form\"},{\"path\":\"/profile\"},{\"path\":\"/qr-codes\"},{\"path\":\"/qr-codes/create\"},{\"path\":\"/settings\"},{\"path\":\"/settings/api-keys\"},{\"path\":\"/settings/connections\"},{\"path\":\"/settings/export\"},{\"path\":\"/team\"},{\"path\":\"/templates\"},{\"path\":\"/templates/form\"},{\"path\":\"/test-sentry\"},{\"path\":\"/tickets\"},{\"path\":\"/accept-invite\"},{\"path\":\"/verify-email-change\"},{\"path\":\"/auth/forgot-password\"},{\"path\":\"/auth/impersonate\"},{\"path\":\"/auth/login\"},{\"path\":\"/auth/register\"},{\"path\":\"/auth/reset-password\"},{\"path\":\"/auth/verify-email\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.0";import * as Sentry from "@sentry/nextjs";
import { attemptChunkReload, isChunkLoadError } from "@/lib/chunk-load-recovery";

// -- Chunk-load recovery ------------------------------------------------
// Registered BEFORE Sentry.init so these listeners run before Sentry's
// global handlers for the same event; beforeSend then sees `reloading`.
let reloading = false;

window.addEventListener("unhandledrejection", (event) => {
  if (!reloading && isChunkLoadError(event.reason)) {
    reloading = attemptChunkReload();
    if (reloading) event.preventDefault();
  }
});
window.addEventListener("error", (event) => {
  if (!reloading && isChunkLoadError(event.error ?? event.message)) {
    reloading = attemptChunkReload();
  }
});

// -- Sentry -------------------------------------------------------------
const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

if (!SENTRY_DSN) {
  // Helpful log so it's obvious why no events are sent
  console.log("[Sentry][client] Skipping initialization - no DSN configured");
} else {
  const environment =
    process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || process.env.NODE_ENV || "development";
  const release = process.env.SENTRY_RELEASE || process.env.VERCEL_GIT_COMMIT_SHA;

  console.log("[Sentry][client] Initializing with DSN:", SENTRY_DSN);

  Sentry.init({
    dsn: SENTRY_DSN,

    // Enable Sentry also in development so GlitchTip receives local events
    enabled: true,

    // Performance monitoring - send all transactions in dev, lower rate in prod
    tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,

    // Release is used for associating events with specific deploys
    ...(release ? { release } : {}),

    // Environment configuration
    environment,

    // Debug mode for development
    debug: process.env.NODE_ENV === "development",

    beforeSend(event, hint) {
      const error = hint.originalException;
      if (isChunkLoadError(error) || isChunkLoadError(event.exception?.values?.[0]?.value)) {
        // Transient failure we are recovering from via reload -> not actionable, drop.
        if (reloading) return null;
        // Persistent failure (survived a reload, or reload unguardable): keep,
        // tag for filtering/alerting, and group into a single issue.
        event.tags = { ...event.tags, chunk_load: true };
        event.fingerprint = ["chunk-load-error"];
      }
      return event;
    },
  });

  console.log("[Sentry][client] Initialized for environment:", environment);
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
